import { Paper, Typography, Divider, Box, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

// Estilizando o título com uma aparência mais moderna
const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.primary.main,
  fontSize: '1.1rem',
}));

// Estilizando a área de scroll
const ScrollableContent = styled(Box)(({ theme }) => ({
  maxHeight: 250,
  overflow: "auto",
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: theme.palette.grey[100],
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: theme.palette.grey[300],
    borderRadius: "10px",
    "&:hover": {
      background: theme.palette.grey[400],
    },
  },
}));

export default function ListSection({ title, items, emptyMessage, renderItem, isLoading }) {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 2, 
        height: "350px", 
        border: "1px solid #e0e0e0", 
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
      }}
    >
      <SectionTitle variant="h6" sx={{ mb: 2 }}>{title}</SectionTitle>
      <Divider sx={{ mb: 2 }} />
      
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "250px" }}>
          <CircularProgress size={30} />
        </Box>
      ) : items && items.length > 0 ? (
        <ScrollableContent>
          {items.map(renderItem)}
        </ScrollableContent>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "250px" }}>
          <Typography variant="body1" color="text.secondary">{emptyMessage}</Typography>
        </Box>
      )}
    </Paper>
  );
}
